import { FormValue } from '@flatsy/types/Applications'

/* -------------------------------------------------------------------------- */
/*                         PROFRESSIONAL STATUS CHECK                         */
/* -------------------------------------------------------------------------- */

export const isEmployed = (professionalSituation: string | undefined): boolean => {
  if (professionalSituation === FormValue.proSituation.EMPLOYED) {
    return true
  }
  return false
}

export const isUnemployed = (professionalSituation: string): boolean => {
  if (professionalSituation === FormValue.proSituation.UNEMPLOYED) {
    return true
  }
  return false
}

export const isWithoutActivity = (professionalSituation: string | undefined): boolean => {
  if (professionalSituation === FormValue.proSituation.WITHOUT_ACTIVITY) {
    return true
  }
  return false
}

export const askDuration = (professionalSituation: string | undefined): boolean => {
  if (
    professionalSituation === FormValue.proSituation.EMPLOYED ||
    professionalSituation === FormValue.proSituation.UNEMPLOYED ||
    professionalSituation === FormValue.proSituation.WITHOUT_ACTIVITY
  ) {
    return true
  }
  return false
}

export const askActivtyDuration = (professionalSituation: string | undefined): boolean => {
  if (
    professionalSituation === FormValue.proStatus.TRADER ||
    professionalSituation === FormValue.proStatus.SELF_EMPLOYED ||
    professionalSituation === FormValue.proStatus.CEO
  ) {
    return true
  }
  return false
}

export const askContractDuration = (professionalSituation: string | undefined): boolean => {
  if (professionalSituation === FormValue.proStatus.CDD) {
    return true
  }
  return false
}

export const askTrialPeriod = (professionalSituation: string | undefined): boolean => {
  if (
    professionalSituation === FormValue.proStatus.CDI ||
    professionalSituation === FormValue.proStatus.CDI_PROBATION
  ) {
    return true
  }
  return false
}

export const askBenefitsDuration = (professionalSituation: string | undefined): boolean => {
  if (professionalSituation === FormValue.proStatus.BENEFITS) {
    return true
  }
  return false
}

export const asGuarantor = (guarantor?: string | null | boolean): boolean => {
  if (guarantor === true || guarantor === 'true') {
    return true
  }
  return false
}

export const asGuarantorPersonnalInformation = (guarantor_type?: string | null): boolean => {
  if (
    guarantor_type === FormValue.guarantorType.FAMILY ||
    guarantor_type === FormValue.guarantorType.FRIEND
  ) {
    return true
  }
  return false
}
